export const breakpoints = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xs: 0,
    sm: 636,
    md: 769,
    lg: 928,
    xl: 1536,
  },
};
